module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Saturday Morning")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Harrie opened her eyes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clear your mind,")]), _vm._v(" she ordered herself"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(". This is no time to remember your crazy dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned back to the ham radio group. They were now farther north and west. No one seemed to notice she wasn’t among them. Then she spied Ginger, standing apart from the rest of the crowd, scanning the area. Ginger waved, and Harrie watched her friend jog down the hill toward her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie hurried to rejoin her. “Where’s the drone now?” she asked, as they closed the distance between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger caught her breath before she responded. “Mark just landed it.” She said, “You scared me, Short Stuff. I looked around, and you were gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie patted her on the back. “I’m fine. You know I’m always exploring. It never occurred to me you’d worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger pushed her long black hair away from her eyes. “I suppose I should have known. You can’t stand still, can you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked slowly to join the crowd of amateur radio operators.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” Harrie said, “has Steve convinced you to get a drone for the family?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger grinned. “It was a done deal before you and I arrived. He’s already planning a trip to the hobby store, and the boys are beside themselves with glee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they reached the group, Harrie noticed a new member she hadn’t met. “Who’s the young guy talking to Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger grabbed Harrie’s arm. “Come on. He’s a friend of Mark’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pulled Harrie along and stopped beside the two men. “Mark,” Ginger said. “Harrie hasn’t met Nick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie flinched and hoped no one noticed. Nick, or more precisely Nicos, was the name of Harrie’s first husband. It irritated her when she still reacted to the name. But that small rush of adrenaline annoyed her the most. Flight or fright syndrome. Harrie pushed all that out of her mind and smiled at Mark and his young friend.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Mark said, “Harrie, this is Nick Ellis. He’s also a drone enthusiast.”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice to meet you Nick,” Harrie said, as she shook his hand. He seemed so young, and bore no resemblance at all to the roguish Nicos Constantine, a point in his favor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger spoke up. “Nick’s been telling us about his job. He’s a ranger at Petroglyphs National Monument.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How interesting,” Harrie said. “I’ve lived here all these years, and I’ve never seen the Petroglyphs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shy smile creased Nick Ellis’s face. “It’s beautiful. You must come pay us a visit. The rock carvings are amazing. The site is covered with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie nodded to Ginger. “Let’s do that soon.” She returned her attention to the ranger. “Tell me, Nick. What’s the most interesting thing about your job?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took in a big breath and shot a glance at Mark. “Well, a few days ago, I would have said just working in such an amazing environment. We see such interesting people. They come from all over the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark nodded. “Nick told me about something that happened on Thursday night. I think it rattled him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A chill went up Harrie’s spine, as though the wind had turned cold and aimed itself directly at her. She forced herself to ignore it. “What upset you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shook his head. “I guess I wasn’t prepared,” he said. “Over the past couple of years I’ve become used to sharing the monument with the spirits of the Ancient Ones. I’m not even freaked out when I feel their presence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger said, “Are you serious? Do you mean there are ghosts at the Petroglyphs?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Nick shook his head. “We don’t think of them that way. The word ‘ghosts’—at least to me—implies a malicious energy, out to scare the living. That’s not the way of The Ancient Ones. The Petroglyphs belong to them. It’s their ancient land. We’re the honored caretakers. Even today, the Pueblo Indians in this area consider it their sacred ground. The Ancient Ones are their ancestors, and they feel the same connection to this site. Everyone, visitors and staff alike, understands they’re being allowed to tread on sacred ground. But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" are the interlopers—not the spirits of The ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Ancient Ones.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("More people had assembled, drones forgotten for the moment, to hear what Nick had to say. The young man realized he had become the center of attention, and he blushed a deep shade of red. “I’m sorry,” he said. “I talk too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A chorus of “No” greeted him, and Harrie said, “Please go on, Nick. This is so interesting. I knew nothing of these Ancient Ones you mentioned.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nick nodded. He seemed to relax a bit. “Well, like I said, I’m no longer nervous in their presence. It comforts me to know they still watch over the land and care for it. That’s why I was so upset two nights ago when I had the duty to close up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A familiar, queasy feeling came over Harrie. She swallowed hard and took a long breath. Her attention drifted from Nick’s story to her dream from two nights ago. She doubted a connection, and yet ….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had missed the first few sentences of what happened Thursday and forced herself to pay attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“… but the coyote jumped over the wall, and I thought he was my big scare for the night. The flashlight played across the floor, and what I thought was a pile of clothes, turned out to be a body.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several of the group reacted. Ginger turned to Harrie, who put her hand to her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger leaned over and whispered, “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie waved her away and shook her head. “Just listen,” she responded in a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger pulled Harrie a small distance away from the group. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several seconds went by before Harrie whispered, “That’s what I wasn’t ready to tell you.” She turned her back to the group, and Ginger leaned in closer to hear her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw that body. I had another one of ‘those’ dreams, and I know I saw this body he’s talking about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger stared at her friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie grabbed her hand and squeezed it. “What do I do now?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674c80ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter04.vue
// module id = 81
// module chunks = 0